import { render } from "./PreviewLinkedin.vue?vue&type=template&id=490934f8&scoped=true"
import script from "./PreviewLinkedin.vue?vue&type=script&lang=js"
export * from "./PreviewLinkedin.vue?vue&type=script&lang=js"

import "./PreviewLinkedin.vue?vue&type=style&index=0&id=490934f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490934f8"]])

export default __exports__